import loadable from '@loadable/component';
import { LOADABLE_NO_SSR } from 'shared/utils/loadable';

/* istanbul ignore next */
export const NewbuildingBrokerBookingExistsModalAdapterLoadable = loadable(
  () =>
    import('./NewbuildingBrokerBookingExistsModalAdapter').catch(() => ({
      NewbuildingBrokerBookingExistsModalAdapter: () => null,
    })),
  {
    resolveComponent: ({ NewbuildingBrokerBookingExistsModalAdapter }) => NewbuildingBrokerBookingExistsModalAdapter,
    ...LOADABLE_NO_SSR,
  },
);
